import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EMPTY, Observable, throwError } from 'rxjs';
import { GlobalComponentService } from '@techmore/global';
import { Router } from '@angular/router';

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {
  /** 正在踢人把頁面轉回login中 */
  isKickingOut = false;

  constructor(
    private injector: Injector,
    private globalComponentService: GlobalComponentService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const router = this.injector.get(Router);

    // @ts-ignore
    return next.handle(req).pipe(catchError(err => {
      // if (!localStorage.getItem('Authorization')) {
      //   // 登入時間過期，已被要求重新登入
      //   return throwError(err);
      // }
      if (/.+?\/backend\/api\/question\/.+\/import\/.+?$/g.test(req.urlWithParams)) {
        // 這些 api 不用全域處理錯誤
        return throwError(err);
      }
      if (err instanceof HttpErrorResponse) {
        const requestId = err.headers.get('X-Request-Id');
        const requestTime = err.headers.get('X-Request-Time');
        const data = err.error;
        let message = data.message;
        switch (err.status) {
          case 500:
          case 700:
            if (data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                const result = JSON.parse(reader.result.toString());
                this.globalComponentService.openErrorAlert(`${result.message}，Request Id: ${requestId}，時間: ${requestTime}`, {title: '錯誤訊息'});
              };
              reader.readAsText(data);

              /** 目前匯出沒有回傳檔案 */
              this.globalComponentService.openErrorAlert(`Request Id: ${requestId}，時間: ${requestTime}`, {title: '錯誤訊息'});
            } else {
              this.globalComponentService.openErrorAlert(`${data.message}，Request Id: ${requestId}，時間: ${requestTime}`, {title: '錯誤訊息'});
            }
            break;
          case 611:
          case 403:
          case 612:
          case 606:
            // 已經在 AuthorizationTokenService 處理了，這裡就直接跳過
            break;
          case 404:
            this.globalComponentService.openErrorAlert('找不到資源', {title: '錯誤訊息'});
            break;
          case 401:
            if (message === '非有效的JWT字串' || (err.url.includes('system/oauth/refresh') && message === 'JWT Token已過期') || message === 'JWT簽名驗證失敗') {
              if (this.isKickingOut) { break; }
              this.isKickingOut = true;
              this.globalComponentService.openErrorAlert(`${message}`);
              localStorage.removeItem('Authorization');
              localStorage.removeItem('jwt-payload');
              localStorage.removeItem('refreshToken');
              router.navigateByUrl('/login');
              this.isKickingOut = false;
              break;
            }
            break;
          case 400:
            if (message === '非有效的JWT字串' || (err.url.includes('system/oauth/refresh') && message === 'JWT Token已過期') || message === 'JWT簽名驗證失敗') {
              if (this.isKickingOut) { break; }
              this.isKickingOut = true;
              this.globalComponentService.openErrorAlert(`${message}`);
              localStorage.removeItem('Authorization');
              localStorage.removeItem('jwt-payload');
              localStorage.removeItem('refreshToken');
              router.navigateByUrl('/login');
              this.isKickingOut = false;
              break;
            }
            if (data.fieldErrors) {
              message = data.fieldErrors.map(fe => {
                // let fieldName: string = (document.querySelector(`label[for="${fe.field}"]`) as HTMLElement).innerText || fe.field;
                // fieldName = fieldName.replace('*', '');
                // return `"${fieldName}" ${fe.message}`;
                return `${fe.message}`;
              }).join('、');
            }
            this.globalComponentService.openErrorAlert(`${message}`, {title: '錯誤訊息'});
            break;
          default:
            this.globalComponentService.openErrorAlert(data.message || '未知錯誤', {title: '錯誤訊息'});
            break;
        }
      }
      throw err;
    }));
  }
}
